export default {
  name: "Edit Account Details",
  sections: [
    {
      fields: [
        {
          isGroup: {
            label: "What type of account is this?",
            machine_name: "account_type",
            coloring: "none",
            fields: [
              {
                widget: "radio",
                choice: "Employer",
                value: "Employer",
              },
              {
                widget: "radio",
                choice: "Agent/Attorney",
                value: "Agent/Attorney",
              },
              {
                widget: "radio",
                choice: "Agricultural Association",
                value: "Agricultural Association",
              },
            ],
          },
        },
      ],
    },
    {
      fields: [
        {
          machine_name: "email",
          widget: "text",
          label: "Email",
          disabled: true,
        },
        {
          machine_name: "last_name",
          widget: "text",
          label: "Last Name",
        },
        {
          machine_name: "first_name",
          widget: "text",
          label: "First Name",
        },
        {
          machine_name: "phone_number",
          widget: "text",
          label: "Phone Number",
        },
        {
          machine_name: "phone_number_ext",
          widget: "text",
          label: "Extension",
        },
        {
          machine_name: "legal_bussiness_name",
          widget: "text",
          label: "Legal Business Name",
        },
        {
          machine_name: "fein",
          widget: "text",
          label: "FEIN",
        },
      ],
    },
  ],
};
